import React from 'react';
import { MotionConfig } from 'framer-motion';
import { BundleProvider } from '../contexts/BundleContext';
import { BrandHeader } from '../components/blackout/BrandHeader';
import { HeroSection } from '../components/blackout/HeroSection';
import { StoryStrip } from '../components/blackout/StoryStrip';
import { PressStrip } from '../components/blackout/PressStrip';
import { FeaturedInSection } from '../components/blackout/FeaturedInSection';
import { MaskSection } from '../components/blackout/MaskSection';
import { BundleSection } from '../components/blackout/BundleSection';
import { ValueLadder } from '../components/blackout/ValueLadder';
import { TrustBar } from '../components/blackout/TrustBar';
import { CrewSection } from '../components/blackout/CrewSection';
import { ReviewsSection } from '../components/blackout/ReviewsSection';
import { FaqSection } from '../components/blackout/FaqSection';
import { FinalCTA } from '../components/blackout/FinalCTA';
import { SiteFooter } from '../components/blackout/SiteFooter';
import { StickyCTA } from '../components/blackout/StickyCTA';
interface BlackoutLandingProps {
  showCrystalBonus: boolean;
}
export function BlackoutLanding({
  showCrystalBonus
}: BlackoutLandingProps) {
  return <MotionConfig reducedMotion="user" data-id="element-1972" data-mp="3l6fe229t5gyv">
      <BundleProvider showCrystalBonus={showCrystalBonus} data-id="element-1973" data-mp="3q4z002oeisr8">
        <div className="min-h-screen w-full bg-obsidian font-sans text-bone antialiased" data-id="element-1974" data-mp="3q4gxiob5biav">
          <BrandHeader data-id="element-1975" data-mp="2tg13aex3ckrf" />
          <main data-id="element-1976" data-mp="2tgsqp2gjbc6m">
            <HeroSection data-id="element-1977" data-mp="2xgba1tspjf7c" />
            <StoryStrip data-id="element-1978" data-mp="2xfru2immb0vy" />
            <PressStrip data-id="element-1979" data-mp="2xh2vibslbwjw" />
            <FeaturedInSection data-id="element-1980" data-mp="2xidyi9e7p09y" />
            <MaskSection data-id="element-1981" data-mp="32fnuy900qc7a" />
            <BundleSection data-id="element-1982" data-mp="32ecrkaahj6gp" />
            <ValueLadder data-id="element-1983" data-mp="32e32cox9l3c2" />
            <TrustBar data-id="element-1984" data-mp="37eha05uyeb9k" />
            <CrewSection data-id="element-1985" data-mp="37f0kx2m6rze3" />
            <ReviewsSection data-id="element-1986" data-mp="37fa8kjjrdugm" />
            <FaqSection data-id="element-1987" data-mp="37cebexfqj9t8" />
            <FinalCTA data-id="element-1988" data-mp="hpfa9dmxvsgx" />
          </main>
          <SiteFooter data-id="element-1989" data-mp="hodoof8arnky" />
          <StickyCTA data-id="element-1990" data-mp="hr9lu1cbm88c" />
        </div>
      </BundleProvider>
    </MotionConfig>;
}